import { render, staticRenderFns } from "./MarkAsSeenButtonView.vue?vue&type=template&id=1d682cce&scoped=true"
import script from "./MarkAsSeenButtonView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MarkAsSeenButtonView.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MarkAsSeenButtonView.vue?vue&type=style&index=0&id=1d682cce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d682cce",
  null
  
)

export default component.exports